var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SignInLayout',{attrs:{"title":this.$t('login.title'),"subTitle":this.$t('login.subtitle', { brandName: _vm.brandName })}},[_c('SignIn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }